import React from "react";

interface CheckboxProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string | React.ReactNode;
}

const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, label }) => {
  return (
    <div
      className={`d-flex justify-content-center align-items-center`}
      style={{ color: "#FF4D4D" }}
    >
      <label className={`d-flex align-items-center cursor-pointer`}>
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className={`me-2 cursor-pointer`}
        />
        <span className="fw-bold my-0">{label}</span>
      </label>
    </div>
  );
};

export default Checkbox;
